import React from 'react';
import { useEffect, useState } from "react";
import { NavBar, Grid, Space, Swiper, List, Tabs, Image, Avatar } from 'antd-mobile'
import { BodyView, ListView, TabsView, OptionView, CoinImgView } from "../factory/ViewUtil";
import { ConvertToRate, FullURL } from '../factory/FactoryUtil';

import { 
    AvatarIcon,
    NavbarFeedbackIcon,
    NavbarMessageIcon,
    RechargeIcon,
    WithdrawIcon,
    FuturesIcon,
    MarketsIcon,
    AppleIcon,
    AndroidIcon
 } from "../icons";

import { 
    CloseCircleOutline,
    SearchOutline, 
} from 'antd-mobile-icons';

import { 
    CellLastPriceHeaderView,
    CellLastPriceView,
    CellStateView
} from '../factory/CellViews';
import { avatarData, RequestPrompt } from '../../NetworkFactory';
import { T } from "../language/LanduagesManager";

const imgs = ['./img/banner2.png', './img/banner1.png']
const items = imgs.map((img, index) => (
    <Swiper.Item key={index}>
       <Image 
        fit="cover" 
        width='100%'
        height={168} 
        src={img}
        placeholder={<div style={{background : '#eee', height : '100%'}}></div>} />
    </Swiper.Item>
))

const tabItems = [
    { key: '1', title: T('favorites') },
    { key: '2', title: T('hot') },
    { key: '3', title: T('gainers') }
]

const CenterView = React.memo(({navpush}) => {
    return(
        <Grid columns={2} style={{
            background : 'rgba(0,0,0, 0.05)', 
            margin : 'auto',
            borderRadius : '100px',
            fontWeight : 'normal',
            }}>
            <Grid.Item onClick={()=>{navpush('/me/about')}}>
                <div style={{
                    border : '2px #000 solid', 
                    padding : '5px 0',
                    boxSizing : 'border-box',
                    borderRadius : '100px',
                    background : '#FFF',
                    }}>{T('crypto')}</div>
            </Grid.Item>
            <Grid.Item>
                <div style={{
                    border : '2px transparent solid', 
                    padding : '8px 0',
                    fontSize : '14px',
                    boxSizing : 'border-box',
                    color : '#A6A6A6',
                    borderRadius : '100px'}} onClick={()=>{navpush('/search/coins')}}><SearchOutline/> {T('search')}</div>
            </Grid.Item>
        </Grid>
    )
});

const LeftView = React.memo(({loginpush}) => {
    return (
        <div style={{ fontSize: 24, marginLeft : '6px' }} onClick={()=>{loginpush('/me')}}>
            {
                avatarData() === '' ? <AvatarIcon /> : <Avatar src={avatarData()} style={{'--border-radius' : '100px', '--size' : '29px'}} />
            }
        </div>
    )
});

const RightView = React.memo(({loginpush, navpush}) => {
    return (
        <div style={{ fontSize: 24, marginRight : '6px' }}>
            <Space style={{ '--gap': '10px' }}>
                <div onClick={()=>{loginpush('./chat')}}><NavbarFeedbackIcon/></div>
                <div onClick={()=>{navpush('./message')}}><NavbarMessageIcon/></div>
            </Space>
        </div>
    )
});

const HomeViewController = ({loginpush, navpush}) => {
    const openKline = (data) => {
        navpush('/trend', false, data);
    };

    const optionData = [
        {
            title : T('recharge'),
            icon : <RechargeIcon/>,
            onClick : () => {
                loginpush('/recharge')
            }
        },
        {
            title : 'Withdraw',
            icon : <WithdrawIcon/>,
            onClick : () => {
                loginpush('/withdraw')
            }
        },
        {
            title : T('futures'),
            icon : <FuturesIcon/>,
            onClick : () => {
                navpush('/trade')
            }
        },
        {
            title : T('market'),
            icon : <MarketsIcon/>,
            onClick : () => {
                navpush('/market')
            }
        },
        {
            title : 'App iOS',
            icon : <AppleIcon/>,
            onClick : () => {
                navpush('/app', false, {ios : true})
            }
        },
        {
            title : 'Android',
            icon : <AndroidIcon/>,
            onClick : () => {
                navpush('/app', false, {ios : false})
            }
        }
    ];

    const [activeIndex, setActiveIndex] = useState('2');
    const onChange = (key) => {
        setActiveIndex(key)
    }
    
    // # 初始化数据
    const [recommendDataSource, setRecommendDataSource] = useState([]);
    const [dataSource, setDataSource] = useState({});
    const [prompt, setPrompt] = useState(localStorage.getItem('home_promot_show')??'0');
    const [promptId, setPromptId] = useState(localStorage.getItem('home_promot_id')??'-1');
    const [promptData, setPromptData] = useState({});
    const loadPrompt = () => {
        RequestPrompt().then(r => {
            const data = r.data.data??{}
            const id = data.id
            if(!id) return

            if(id === promptId && prompt === '0') {
                return
            }
            setPromptData(r.data.data??{})
            localStorage.setItem('home_promot_id', id)
            setPromptId(id)
            localStorage.setItem('home_promot_show', '1')
            setPrompt('1')
        })
    }
    const closePrompt = () => {
        localStorage.setItem('home_promot_show', '0')
        setPrompt('0')
    }

    useEffect(() => {
        // # 币种市场
        React.ListenerCandlestickDataSource('homepage', (data) => {
            let hotDataSource = []
            let recommendDataSource = []
            let favoritesDataSource = []
            data.forEach((item) => {
                // # host
                if(item.hot === 1) {
                    hotDataSource.push(item)
                }
                // # recommend
                if(item.recommend === 1 && recommendDataSource.length < 6) {
                    recommendDataSource.push(item)
                }
                // # Favorites
                if(item.isFollowed) {
                    favoritesDataSource.push(item)
                }
            })
            setRecommendDataSource(recommendDataSource)
            const sortData = [...data].sort((a, b) => {
                return ConvertToRate(b) - ConvertToRate(a)
            });
            setDataSource({'1' : favoritesDataSource, '2' : hotDataSource, '3' : sortData})
        });

        loadPrompt()

        // # componentWillUnmount
        return () => {
            React.ListenerCandlestickRemove('homepage')
        }


    }, []);

    return(
        <>
            <div className='fixed-nav-bar'>
                <NavBar 
                right={<RightView loginpush={loginpush} navpush={navpush}/>} 
                backIcon={<LeftView loginpush={loginpush}/>} 
                style={{height : '52px'}}><CenterView navpush={navpush}/></NavBar>
            </div>
            <BodyView>
                <ListView paddingTop = {'52px'} paddingBottom = {'50px'} >
                    <List.Item style={{marginTop : '20px'}}>
                        <Swiper indicator={false} loop style={{borderRadius : '16px'}}>
                            {items}
                        </Swiper>
                    </List.Item>
                    <List.Item style={{margin : '20px 0'}}><OptionView data={optionData} columns={4}/></List.Item>
                    <List.Item style={{margin : '10px 0'}}>
                        <Space wrap>
                            {
                                recommendDataSource.map((item, index) => (
                                    <CoinImgView 
                                    src={FullURL(item.logo) || ''} key={index} 
                                    onClick={()=>{openKline(item)}} 
                                    style={{'--border-radius' : '16px', '--size' : '32px'}}/>
                                ))
                            }
                        </Space>
                    </List.Item>

                    <List.Item style={{marginBottom : '20px'}}>
                        <TabsView className="adm-tabs-tab-list-border" activeKey={activeIndex}
                            onChange={onChange}>
                            {
                                tabItems.map(item => (
                                    <Tabs.Tab title={item.title} key={item.key} />
                                ))
                            }
                        </TabsView>
                    </List.Item>
                    <CellLastPriceHeaderView/>
                    {
                        (dataSource[activeIndex] || []).length <= 0 ? <CellStateView stateType={4}/> : ''
                    }
                    {
                        (dataSource[activeIndex] || []).map((item, index) => (
                            <CellLastPriceView
                                avatar={activeIndex === '1'}
                                item={item}
                                key={index} 
                                onClick={()=>{openKline(item)}}/>
                        ))
                    }
                </ListView>
            </BodyView>
            {prompt === '1' && <div style={{
                position : 'absolute',
                zIndex : 1000,
                inset : 0,
                display : 'flex',
                alignItems : 'center',
                justifyContent : 'center',
                background : 'rgba(0,0,0,0.6)'
            }}>
                <div style={{
                    background : '#fff',
                    width : '85%',
                    maxWidth : '600px',
                    minHeight : '200px',
                    borderRadius : '10px',
                    position : 'relative',
                }}>
                    
                    {/* <div style={{
                        position : 'absolute',
                        right : 9,
                        top : 9,
                        fontSize : 20
                    }} onClick={()=>{closePrompt()}}>
                        <CloseCircleOutline />
                    </div>

                    <div style={{fontSize : '18px', fontWeight : 'bold', borderBottom : '1px #eee solid', paddingBottom : '10px'}}>Important Notice</div> */}
                    <div style={{
                        display : 'flex',
                        borderBottom : '1px #eee solid',
                        padding : 10
                    }}>
                        <div style={{
                            fontSize : '18px', 
                            fontWeight : 'bold', 
                            flex : 1
                        }}>Important Notice</div>
                        <div style={{fontSize : 20}} onClick={()=>{closePrompt()}}><CloseCircleOutline /></div>
                    </div>
                    <div style={{
                            fontSize : '16px', 
                            overflow : 'auto',
                            maxHeight : '320px',
                            padding : '0px 10px 10px 10px',
                        }} 
                        dangerouslySetInnerHTML={{__html : promptData.body}}
                        />
                </div>
            </div>}
        </>
    );
}
export default React.memo(HomeViewController)